module.exports = __webpack_public_path__ + "static/media/it-consulting.634ce6d9.png";